import { IUser } from "screens/Admin/RolesAndUsers/users.types";

const rolesMap: Record<IUser['userRole'], string> = {
  STUDENT: 'Студент',
  EXPERT: 'Эксперт',
  INSPECTOR: 'Проверяющий',
  ADMIN: 'Админ',
}

const rolesOptions = Object.keys(rolesMap) as IUser['userRole'][]

const userRolesConstants = {
    rolesMap,
    rolesOptions,
}

export default userRolesConstants